(function () {
    'use strict';

    var module = angular.module('uwAgenda.email');
    module.controller('DetailEmailMessageController', ['$uibModalInstance', DetailEmailMessageControllerFn]);

    /* controlle for email modal */
    function DetailEmailMessageControllerFn($uibModalInstance) {
        var vm = this;

        activate();

        // cancel modal
        vm.close = function () {
            $uibModalInstance.dismiss("abort");
        };

        /* activation work */
        function activate() {
        }
    }
})();